// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Products/components/ProductCarousel/index.css
// module id = 2342
// module chunks = 0